import React, { useEffect, useState } from "react";
import { FiChevronUp } from "react-icons/fi";
import "./ScrollToTopButton.css";

export default function ScrollToTopButton() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > 420);
    };

    onScroll();

    window.addEventListener("scroll", onScroll, {
      passive: true,
    });

    return () => {
      window.removeEventListener("scroll", onScroll);
    };
  }, []);

  const scrollToTop = (event) => {
    event.currentTarget.blur();

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      type="button"
      className={`scroll-to-top${visible ? " show" : ""}`}
      onClick={scrollToTop}
      aria-label="Volver arriba"
    >
      <FiChevronUp size={23} strokeWidth={2.4} />
    </button>
  );
}
